import './global.css'

import { QueryClientProvider } from 'react-query'
import { BrowserRouter, useLocation } from 'react-router-dom'

import { AppRoutes } from '@/app.routes'
import { ErrorBoundary } from '@/components/common/error-boundary'
import ScrollToAnchor from '@/components/common/ScrollToAnchor'
import { Toaster } from '@/components/ui/sonner'
import { UserAbilityProvider } from '@/features/sessao/providers/auth-context'
import { queryClient } from '@/lib/queryClient'

import { TooltipProvider } from './components'

function RoutesWithErrorBoundary() {
  const { pathname } = useLocation()

  // The boundary stays mounted across navigation (see resetKey comment in
  // error-boundary.tsx) and clears itself once the user moves to a new page.
  return (
    <ErrorBoundary resetKey={pathname}>
      <AppRoutes />
    </ErrorBoundary>
  )
}

function Component() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <UserAbilityProvider>
            <RoutesWithErrorBoundary />
            <ScrollToAnchor />
            <Toaster />
          </UserAbilityProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

export default Component
